module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAABmdX9mdX9mdX9mdX9mdX9mdX/Gy4RTt7T//4dH3tRuRd2GAAAABnRSTlMAML+vAO9oBwRvAAABBklEQVR4Xu3WwUkDURhG0diDtmAJsw+kATc2MPi0AsEGXNiA2IGkSocQOLy5HUi+xSwel7P953DZ3eN6f8qOy/X1cPk+jPE0BV5FyxgvoY7PY6yi09iGAo0xRe8o0Nsu+kaBvnbRDwp03kcoUCIUKBEKlAgFSoQCJUKBEqFAiVCgRChQIhQoEQqUCAVKhAIlQoESoUCJUKBEKFAiFCgRCpTIzv8xukW36EOk+Z2iZbyKRJ9jnU8ZCuSUXW8ECrRdEtFMBdqiUIG2KFSgLQoVaItCBRKhQKJQIFEokCgUSBQKJAoFEoUCiUKBRKFAolAgUSiQKBRIFAokCgUShQKJSoFE5r9x3h9CwiyJteQmmwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f530.png
// module id = 1123
// module chunks = 0